<template>
  <div>
    <h1 v-if="!isChangingCampaign" class="tw:font-bold tw:mb-8 tw:text-2xl tw:mx-auto tw:text-center">
      {{ $t('rc_setup_commission_header') }}
    </h1>
    <p
      class="commission-benefits tw:max-w-screen-md tw:md:max-w-fit tw:mb-8"
      :class="isChangingCampaign ? 'tw:text-center tw:md:text-left tw:px-4 tw:md:px-0' : 'tw:mx-auto'"
      v-html="
        selectedCampaignType.toLowerCase() === 'netcpa'
          ? $t('rc_ncpa_commission_benefits')
          : $t('rc_gcpa_commission_benefits')
      "
    ></p>
    <ul class="tw:flex tw:md:flex-row tw:flex-col tw:justify-between tw:mb-8" :class="getClasses">
      <li
        v-for="commissionLevel in eligibleCommissionLevels"
        :key="commissionLevel"
        :class="isChangingCampaign ? 'tw:mb-4 last:tw:mb-0' : 'tw:mb-4 tw:md:mb-0 last:tw:mb-0'"
      >
        <button
          @click="updateCommission(commissionLevel)"
          :class="isChangingCampaign ? 'tw:w-full tw:md:w-auto' : 'tw:w-full'"
        >
          <CommissionLevelSelectCardNew
            :isChangingCommission="isChangingCommission"
            :isSelected="selectedCommissionLevel === commissionLevel"
            :commissionValue="commissionLevel"
          />
        </button>
      </li>
    </ul>
    <p v-if="selectedCampaignType.toLowerCase() === 'netcpa'" class="tw:text-center tw:text-gray-700 tw:mt-8">
      {{ $t('rc_pay_per_stay_billing_footnote') }}
    </p>
  </div>
</template>
<script setup>
import { computed, onMounted } from 'vue'

import CommissionLevelSelectCardNew from '../CommissionLevelSelectCardNew.vue'

const props = defineProps({
  eligibleCommissionLevels: {
    type: Array,
    required: true,
    default: () => [],
  },
  selectedCommissionLevel: {
    type: Number,
    required: false,
    default: 18,
  },
  selectedCampaignType: {
    type: String,
    required: true,
    default: 'netcpa',
    validator(value) {
      return ['netcpa', 'cpa'].includes(value)
    },
  },
  isChangingCampaign: {
    type: Boolean,
    default: false,
  },
  isChangingCommission: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['onSelectedCommissionChange'])

const updateCommission = level => {
  emit('onSelectedCommissionChange', level)
}

const getClasses = computed(() => {
  const classes = []
  if (props.isChangingCampaign) {
    classes.push('tw:my-10')
  }
  if (props.isChangingCommission) {
    classes.push('tw:gap-x-6')
  }
  return classes.join(' ')
})
onMounted(() => {
  if (
    props.selectedCommissionLevel === 12 ||
    props.selectedCommissionLevel === 25 ||
    props.selectedCommissionLevel === 15 ||
    props.selectedCommissionLevel === 20
  ) {
    if (!props.isChangingCommission) {
      updateCommission(18)
    }
  }
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant',
  })
})
</script>

<style scoped>
.commission-benefits :deep(ul) {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  list-style-type: disc;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
</style>
